<template>
  <v-data-table
    dense
    :headers="headers"
    :items="items"
    :loading="loading"
    loading-text="Loading... Please wait"
    :single-expand="true"
  >
    <template v-slot:top>
      <v-container
        class="text-center"
      >
        Exception for #{{ hashtagName }}
      </v-container>
    </template>

    <template v-slot:body.append>
      <tr>
        <td/>
        <td>
          <GeotagList
            :geotag-model.sync="newException.geotagId"
            label="select geotag to add exception"
          />
        </td>
        <td>
          <v-edit-dialog>
            <div
              v-if="newException.subtitle"
              class="font-weight-black"
            >{{ newException.subtitle }}</div>
            <div v-else class="font-italic font-weight-thin red--text" v-text="'empty'"/>
            <template v-slot:input>
              <v-text-field
                v-model="newException.subtitle"
                label="Edit"
                single-line
              />
            </template>
          </v-edit-dialog>
        </td>
        <td>
          <v-edit-dialog>
            <div
              v-if="newException.title"
              class="font-weight-black"
            >{{ newException.title }}</div>
            <div v-else class="font-italic font-weight-thin red--text" v-text="'empty'"/>
            <template v-slot:input>
              <v-text-field
                v-model="newException.title"
                label="Edit"
                single-line
              />
            </template>
          </v-edit-dialog>
        </td>
        <td>
          <v-btn
            class="mx-2"
            x-small
            :dark="!!newException.geotagId"
            color="green"
            :disabled="!newException.geotagId"
            @click="addException()">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    dark
                  >
                  mdi-plus
                  </v-icon>
                </template>
                add exception
              </v-tooltip>
          </v-btn>
        </td>
      </tr>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn
        v-if="!hasSomeAbilities($constants.ABILITY.INTERN)"
        icon
        @click="deleteException(item.id)"
      >
        <v-icon
          color="red"
        >
          mdi-delete
        </v-icon>
      </v-btn>
    </template>

    <template v-slot:item.title="{ item }">
      <v-edit-dialog
        @save="updateExceptionTitle(item.id, item.title)"
      >
        <div
          v-if="item.title"
          class="font-weight-black"
        >{{ item.title }}</div>
        <div v-else class="font-italic font-weight-thin red--text" v-text="'empty'"/>
        <template v-slot:input>
          <v-text-field
            v-model="item.title"
            label="Edit"
            single-line
          />
        </template>
      </v-edit-dialog>

      <translations-bar
        :id="item.id"
        :translations="translationsExceptionsTitles[item.id]
         ? translationsExceptionsTitles[item.id] : {}"
        :model="$constants.TRANSLATION_MODELS.HASHTAG_EXCEPTION_TITLE"
        :title="item.name"
        :trigger-update="item.title"
      >
      </translations-bar>
    </template>

    <template v-slot:item.subtitle="{ item }">
      <v-edit-dialog
        @save="updateExceptionSubtitle(item.id, item.subtitle)"
      >
        <div
          v-if="item.subtitle"
          class="font-weight-black"
        >{{ item.subtitle }}</div>
        <div v-else class="font-italic font-weight-thin red--text" v-text="'empty'"/>
        <template v-slot:input>
          <v-text-field
            v-model="item.subtitle"
            label="Edit"
            single-line
          />
        </template>
      </v-edit-dialog>

      <translations-bar
        :id="item.id"
        :translations="translationsExceptionsSubtitles[item.id]
         ? translationsExceptionsSubtitles[item.id] : {}"
        :model="$constants.TRANSLATION_MODELS.HASHTAG_EXCEPTION_SUBTITLE"
        :title="item.name"
        :trigger-update="item.subtitle"
      >
      </translations-bar>
    </template>

    <template v-slot:item.geotag="{ item }">
      {{ geotagName(item.geotag_id) }}
    </template>
  </v-data-table>
</template>

<script>
import fetchErrorMixin from '../mixins/fetchErrorMixin';
import TranslationsBar from './Translations/TranslationsBar.vue';
import GeotagList from './DataLists/GeotagList.vue';

export default {
  name: 'ExceptionForm',
  components: {
    GeotagList,
    TranslationsBar,
  },
  mixins: [fetchErrorMixin],
  props: {
    hashtagId: {
      type: Number,
      default: NaN,
    },
    hashtagName: {
      type: String,
      default: '',
    },
    geotags: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    loading: true,
    items: [],
    newException: {
      geotagId: NaN,
      title: '',
      subtitle: '',
    },
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'GeoTag', value: 'geotag' },
      { text: 'Subtitle', value: 'subtitle' },
      { text: 'Title', value: 'title' },
      { text: '', value: 'actions', sortable: false },
    ],
    translationsExceptionsTitles: {},
    translationsExceptionsSubtitles: {},
  }),

  methods: {
    getHashtagExceptions() {
      this.$requestHelpers
        .get(`api/admin/hashtag/getExceptions/${this.hashtagId}`)
        .then((response) => {
          this.items = response.data.result;
          this.getTranslationsExceptions();
          this.loading = false;
        }).catch((error) => {
          this.$emit('error', this.fetchError(error));
        }).finally(() => {
          this.loading = false;
        });
    },

    addException() {
      this.loading = true;
      this.$requestHelpers
        .post('api/admin/exceptions',
          {
            hashtag_id: this.hashtagId,
            geotag_id: this.newException.geotagId,
            title: this.newException.title,
            subtitle: this.newException.subtitle,
          }).then((response) => {
          if (response.data.success) {
            this.items.push(response.data.result);
            this.$emit('added', this.hashtagId, this.items.length);
            this.getTranslationsExceptions();
          }
          this.resetNewException();
        }).catch((error) => {
          this.$emit('error', this.fetchError(error));
        }).finally(() => {
          this.loading = false;
        });
    },

    deleteException(exceptionId) {
      this.$confirm('Are you sure you want to delete this exception?').then((res) => {
        if (!res) return;

        this.loading = true;
        this.$requestHelpers
          .delete(`api/admin/exceptions/${exceptionId}`)
          .then((response) => {
            if (response.data === 1) {
              this.items = this.items.filter(
                (el) => el.id !== exceptionId,
              );
              this.$emit('deleted', this.hashtagId, this.items.length);
            }
          }).catch((error) => {
            this.$emit('error', this.fetchError(error));
          }).finally(() => {
            this.loading = false;
          });
      });
    },

    updateExceptionTitle(exceptionId, title) {
      this.loading = true;

      this.$requestHelpers.patch(`api/admin/exceptions/${exceptionId}`,
        {
          exception_id: exceptionId,
          title,
        }).then((response) => {
        if (response.data.success) {
          const elementIndex = this.items.findIndex((el) => el.id === exceptionId);
          this.items[elementIndex] = response.data.result.title;
          this.$emit('updated');
        }
      }).catch((error) => {
        this.$emit('error', this.fetchError(error));
      }).finally(() => {
        this.loading = false;
      });
    },

    updateExceptionSubtitle(exceptionId, subtitle) {
      this.loading = true;

      this.$requestHelpers.patch(`api/admin/exceptions/${exceptionId}`,
        {
          exception_id: exceptionId,
          subtitle,
        }).then((response) => {
        if (response.data.success) {
          const elementIndex = this.items.findIndex((el) => el.id === exceptionId);
          this.items[elementIndex] = response.data.result.title;
          this.$emit('updated');
        }
      }).catch((error) => {
        this.$emit('error', this.fetchError(error));
      }).finally(() => {
        this.loading = false;
      });
    },

    geotagName(geotagId) {
      const geotag = this.geotags.find((el) => el.id === geotagId);

      let name = '';
      if (geotag) {
        name = geotag.name;
      }

      return name;
    },

    resetNewException() {
      this.newException = {
        geotagId: NaN,
        title: '',
        subtitle: '',
      };
    },

    getTranslationsExceptions() {
      this.$requestHelpers.post(
        'api/admin/bulk-translations-by-types',
        {
          models: [
            this.$constants.TRANSLATION_MODELS.HASHTAG_EXCEPTION_TITLE,
            this.$constants.TRANSLATION_MODELS.HASHTAG_EXCEPTION_SUBTITLE,
          ],
          ids: this.items.map((item) => item.id),
        },
      ).then((response) => {
        // eslint-disable-next-line max-len
        this.translationsExceptionsTitles = response.data.result[this.$constants.TRANSLATION_MODELS.HASHTAG_EXCEPTION_TITLE];
        // eslint-disable-next-line max-len
        this.translationsExceptionsSubtitles = response.data.result[this.$constants.TRANSLATION_MODELS.HASHTAG_EXCEPTION_SUBTITLE];
      });
    },
  },

  created() {
    this.loading = true;
    this.getHashtagExceptions();
  },
};
</script>

<style scoped>

</style>
